import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LogoutIcon from '@mui/icons-material/Logout';
import Collapse from '@mui/material/Collapse';

import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [

 { id: 'or_orderno', numeric: false, label: 'Invoice No.' },
  { id: 'or_name', numeric: false, label: 'Name' },
  { id: 'or_email', numeric: false, label: 'Email Id' },
  { id: 'or_phone', numeric: false, label: 'Phone No.' },  
{ id: 'cs_date', numeric: false, label: 'Date' },  
{ id: 'classtype', numeric: false, label: 'Preference' },  
  { id: 'sb_title', numeric: false, label: 'Duration' },
  { id: 'sm_slotname', numeric: false, label: 'Slot' },    
  { id: '', numeric: false,  label: '' },

]
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  Admincustomerpostpone extends Component {
	constructor(props) {
    super();
	
	 this.state = {custschedule:[],totalcnt:0,rowsPerPage:50,page: 0 ,prevpage:0,redirect:false,pagename:'',order:'desc' ,orderBy:'',name:'',csid:'',orid:'',smid:'',type:'',celldate:'',postponetype:'',cu_id:'',Branchdata:[],branchid:''}
	this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {  this.ApiPostponecall(this.state.page,this.state.rowsPerPage); }
	
	myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
   

  this.setState({[nam]: val});

}

componentDidMount() {
	
		document.title = "Atha yoga Living - Schedule Postpone";  
	
			  
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
 

  this.ApiPostponecall(this.state.page,this.state.rowsPerPage); 
this.onloadBranch();
  
	}
	ApiPostponecall(page,rowsPerPage){
		let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }	
  
  axios.get(Serverurl+'ajaxcustomerschedule.php?action=getpostpone&or_name='+this.state.name+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&cs_postponeclass='+this.state.postponetype+'&or_bm_id='+strbranch)
  .then(resp => {  
		
    if(resp.data.length>0){

			this.setState({  
			  custschedule: resp.data,  
			   totalcnt:parseInt(resp.data[0].count),
			});	 
     }
	 else{
		   this.setState({custschedule:[],totalcnt:0});
	 }
   
    });

}
onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.branchid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        });
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
   
  });
	
}
handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

   
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.ApiPostponecall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.ApiPostponecall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
   
  AttendeClass(csid){
 let r = window.confirm("Do you really want to set Attended");
		 if(r == true){ //sign Out logic
		   var formData = new FormData(); 
					 formData.append('action','attend')
					 formData.append('cs_id',csid)
					
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomerschedule.php", formData, {
						}).then(res => {
					
							this.ApiPostponecall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 
   onClickSearch=()=>{  
  
  this.ApiPostponecall(this.state.page,this.state.rowsPerPage);

  } 
RescheduleRequest(csid,orid,classtype,celldate,cu_id){
	
	 let r = window.confirm("Do you really want to Re-Schedule?");
		 if(r == true){ //sign Out logic
		  this.setState({csid :csid,cu_id:cu_id,orid:orid,type:classtype,celldate:celldate},()=>{
			  
			  this.refs.Addschedulebox.handleClickOpen()}); 
		 }
 
 }
 AccpetRejectnotAttendrequest(csid, type){
	 let strmsg="Approve";
	 if(type===2)
	 {
		strmsg ="Reject";
	 }
	 if(type===4)
	 {
		strmsg ="Not Attended";
	 }
 let r = window.confirm("Are your sure to update status as "+strmsg+"?");
		 if(r == true){ //sign Out logic
		   var formData = new FormData(); 
					 formData.append('action','reject')
					 formData.append('cs_id',csid)
					
					 formData.append('status',type)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomerschedule.php", formData, {
						}).then(res => {
					
							this.ApiPostponecall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 }
 //item.or_id,item.or_classtype,item.or_enddate
render() {

	if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
  
  <React.Fragment>
   
 
 <div className="boxheading">
				
<h2>Schedule Postpone Request</h2>

</div><div className="clear"></div>



 <div className="searchmaster"> 




<ul>
	{localStorage.getItem("AYLrole")==="1" && (
  <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
  )}
<li>
 
<p>Name/Email/Phone No.</p>
		<p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.name}
            id="name"
                inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
            name="name" onChange={this.myChangeHandler}
         
           
          /></p>
		
		</li><li><p>Type</p>
		 <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal" inputProps={{tabIndex: "2"}} className="txtbox" 
          onChange={this.myChangeHandler}
          id="postponetype"
		   value={this.state.postponetype}
		  name="postponetype"
		
        >
	
	<option value="">Select Type</option>
          <option value={1}>Postpone Requested</option>
          <option value={2}>Postpone Rejected</option>
 <option value={3}>Postpone Approved</option>
 <option value={4}>Not Attended</option>
  <option value={5}>Re-Scheduled</option>

        </Select>

		</FormControl>
		</p>
		</li>
		<li>
 
<p >
		<Button variant="contained" onClick={this.onClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p>
 </li>
 
 </ul>
</div>
<div className="clear"></div>

<Addschedulebox ref="Addschedulebox" celldate={this.state.celldate} csid={this.state.csid} type={this.state.type} cu_id={this.state.cu_id} orid={this.state.orid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.custschedule.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.custschedule, getSorting(this.state.order, this.state.orderBy)).map((item,index) =>{
 if(this.state.totalcnt>0)					
	 {  
 return ( <React.Fragment>
 <TableRow key={index} >

	
	 <TableCell>{item.or_orderno}</TableCell>

  <TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_phone}</TableCell>
<TableCell>{item.or_email}</TableCell>
	<TableCell>{item.cs_date}</TableCell>
	<TableCell>{item.classtype}</TableCell>
<TableCell>{item.sb_title}</TableCell>	
	<TableCell>{item.sm_slotname}</TableCell>
	
	<TableCell>
	{item.cs_postponeclass==="5" && ( <React.Fragment>
	
	
	
	<Button variant="contained" className="frmSecondarybtn"  endIcon={<EventAvailableIcon />}>
Scheduled
</Button>&nbsp;	</React.Fragment>	
	)}
	{item.cs_postponeclass==="1" && ( <React.Fragment>
	<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.AccpetRejectnotAttendrequest(item.cs_id,3)}} endIcon={<DoneIcon />}>
Approve
</Button>&nbsp;	

<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.AccpetRejectnotAttendrequest(item.cs_id,2)}}  endIcon={<CloseIcon />}>
Reject
</Button>&nbsp;	
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.AccpetRejectnotAttendrequest(item.cs_id,4)}} endIcon={<LogoutIcon />}>
	Not Attend
	</Button>		
	 </React.Fragment>)}
	{item.cs_postponeclass==="3" && (<React.Fragment>
	<Button variant="contained" className="frmSecondarybtn"  endIcon={<EventAvailableIcon />}>
Approved
</Button>&nbsp;	
<Button variant="contained" className="frmSecondarybtn"  onClick={()=>{this.RescheduleRequest(item.cs_id,item.or_id,item.or_classtype,item.or_enddate,item.or_cu_id)}} endIcon={<EventAvailableIcon />}>
Re-Schedule
</Button>&nbsp;	</React.Fragment>	
	)}
	{item.cs_postponeclass==="2" && (<React.Fragment>
	<Button variant="contained" className="frmSecondarybtn"  endIcon={<CloseIcon />}>
Rejected
</Button>
&nbsp;	
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.AccpetRejectnotAttendrequest(item.cs_id,4)}} endIcon={<LogoutIcon />}>
	Not Attend
	</Button>

	</React.Fragment>)}&nbsp;	
	{item.cs_postponeclass==="4" && (
	<Button variant="contained" className="frmSecondarybtn"  endIcon={<LogoutIcon />}>
Not Attended
</Button>
	)}
	</TableCell>
	


 </TableRow>


				</React.Fragment>	
				);
	 }
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="6">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totalcnt}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />    
  </Paper>
   
</React.Fragment>

		  );
  }	
   
   
  
  
  
  
	
}
export  class  Addschedulebox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {open:false,stsdate:'',errormessage:'',erropen:false,alerttyep:"error",stsdate1:'',lcid:'1',staff:'',slotid:'',locid:'',staffarray:[],slotData:[],postdisable:false,btnSavepost:'Save'}
	  
   }
   handleClickClose= (e) => { this.setState({open:!this.state.open,}); }
     handleClickOpen = (e) => {
	 

	  var date = new Date();
	  
	   var month="";
	let strlcid="";
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	  if(this.props.type==="1")
	 {
		strlcid="3"; 
	 }
	else if(this.props.type==="6")
	 {
		strlcid="6"; 
	 }
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 ,open:!this.state.open,lcid:strlcid});
	  this.onloadStaffbind();this.onloadslot();
	   }
	  
   onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
		
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
      })   
    }
	
	
onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getall&sm_slottype='+this.props.type+'&sorting=sm_order')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotData:resp.data	
							},()=>{
								
								
								 let slotApi = this.state.slotData.map(row => {
                          
          return {value:row.sm_id,display:row.sm_slotname}
        });
      
		
        this.setState({
          slotData: [{value: '0', display:'Select Slot'}].concat(slotApi)
        });
								
							})

	
			}else{
				this.setState({slotData:[]});
			}
 
    });
		
	}
	myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  } 
    handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({lcid: event.target.value});
	}
  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  handleSave=(event)=>{
	let stsdate1 = this.state.stsdate1;
let lcid = this.state.lcid;
let slotid = this.state.slotid;	

let staff = this.state.staff;
  
if(stsdate1==="")
{
	
	this.setState({errormessage:"Please Enter Date",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}if(lcid==="")
{
	
	this.setState({errormessage:"Please Select Preference",erropen:true});
		 window.scrollTo({      top: 0    })
		 return false;
	
	
}if(slotid==="")
{
	
	this.setState({errormessage:"Please Select Slot",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
		
}
if(staff==="")
{
	
	this.setState({errormessage:"Please Select Staff",erropen:true});
		 window.scrollTo({  top: 0  })
		 return false;
		
}

this.setState({errormessage:"",erropen:false,postdisable:true,btnSavepost:'Processing...'});
var formData = new FormData();
formData.append('action','reschedule') 
formData.append('cs_date',stsdate1)
 formData.append('cs_st_id',staff)
  formData.append('cs_or_id',this.props.orid)
   formData.append('cs_sm_id',slotid)
    formData.append('cs_id',this.props.csid)
	 formData.append('lc_id',lcid) 
	 formData.append('or_booktype',this.props.type)
	  formData.append('cu_id',this.props.cu_id) 
	 	 formData.append('userid',localStorage.getItem("AYLuserid"))
	 axios.post(Serverurl+"ajaxcustomerschedule.php", formData, {
        }).then(res => {
			
			if(res.data ===-1)
				{
				this.setState({errormessage:"Please check with another Staff",erropen:true,postdisable:false,btnSavepost:'Save'});	
				}
				else if(res.data ===0)
				{
					this.setState({errormessage:"Please check with another date and slot",erropen:true,postdisable:false,btnSavepost:'Save'});
				
					
		}else{
			this.setState({errormessage:"Request accepted successfully",alertype:"info",postdisable:false,btnSavepost:'Save',erropen:true,open:false},()=>{this.props.updateDonenew();});
		}
		
  });
  }
  render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  Schedule
	  </DialogTitle>
      <DialogContent><p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>  <div className="scheduelpop">
	  <ul>
	  <li><p><span className="validation">*</span> Date
		</p>
	<p>
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.stsdate) }
className="txtbox" minDate={dayjs(Date.now()) }

maxDate={dayjs(this.props.celldate) }
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
	  </li>
	  <li>
<p><span className="validation">*</span>Select Your Location</p>

<FormControl className="location">
  
      <RadioGroup  value={this.state.lcid}
        defaultValue={this.state.lcid}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangeClass}
      >
        {(this.props.type==="3" || this.props.type==="4"  || this.props.type==="2")&& (
	  <React.Fragment>
	   <FormControlLabel value="5" control={<Radio />} label="Studio Class" />
        <FormControlLabel value="4" control={<Radio />} label="Personal Training Room 03 " />
		</React.Fragment>
	  )}
	   
	   {(this.props.type==="2" )&& (
	  <React.Fragment>
        <FormControlLabel value="1" control={<Radio />} label="Personal Training Room 01 " />
		<FormControlLabel value="2" control={<Radio />} label="Personal Training Room 02 " />
		</React.Fragment>
	  )}
	   {(this.props.type==="6" )&& (
	  <React.Fragment>
        <FormControlLabel value="6" control={<Radio />} label=" Personal Training Online" />
		</React.Fragment>
	  )}
      </RadioGroup>
    </FormControl>

</li><li>
<p><span className="validation">*</span> Select Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.slotid}
			onChange={this.myChangeHandler}
			name='slotid'
			
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
<li><p><span className="validation">*</span> Select Staff</p>
<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
</li>

</ul>

		
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave} disable={this.state.postdisable}  className="frmSecondarybtn">
          {this.state.btnSavepost}
        </Button>
		</div></div>
<div className="clear"></div>	</div>
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 



